<template>
    <div class="control test-question-answer-options">
        <div class="test-question-answer-option-container" >
            <textarea
                class="textarea"
                :placeholder="trans.show_form.number_input_placeholder"
                v-model="result"
            ></textarea>
        </div>
    </div>
</template>

<script>
export default {
    name: "TestQuestionTextInputAnswer",
    props: [
        'value',
        'options',
        'trans',
    ],
    computed: {
        result: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/variables';

.test-question-answer-options {
    padding: 0 15px;
}

.test-question-answer-option-container {
    padding: 17px 0;
}

.text-max-length {
    font-size: 0.8rem;
    text-align: right;
    padding-top: 10px;
    color: $tests-grey;
}
</style>